export const oidcTypes = {
  GET_CONFIGURATION: "oidc/GET_CONFIGURATION",
};
